import { useState, useEffect } from "react";
import { useLocalStorage } from "react";
import Number from "./components/Number";

function App() {
  const [result, setResult] = useState(" ");
  const [theme, setTheme] = useState("");

  useEffect(() => {
    if (window !== "undefined") {
      let LocalTheme = window.localStorage.getItem("theme");
      setTheme(LocalTheme);
    }
  }, []);

  const switchTheme = (Theme) => {
    const newTheme = Theme;
    window.localStorage.setItem("theme", newTheme);
    setTheme(newTheme);
  };

  const setProperty = (a) => {
    let positionBtn = document.querySelector(".positionBtn");
    positionBtn.style.left = a;
  };

  const toggleBtn = document.querySelectorAll(".t-btn");
  toggleBtn.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      let target = e.target;
      target.classList.contains("first")
        ? setProperty("8px")
        : target.classList.contains("second")
        ? setProperty("33px")
        : setProperty("63px");
    });
  });

  return (
    <main data-theme={theme}>
      <div className="calci">
        <section className="upper">
          <h1 className="title">calc</h1>
          <div className="theme-options">
            <h2 className="theme-text">Theme</h2>
            <div className="toggle-btn">
              <div className="positionBtn"></div>
              <button
                type="button"
                onClick={() => switchTheme("dark")}
                className="first t-btn"
              ></button>
              <button
                type="button"
                onClick={() => switchTheme("light")}
                className="second t-btn"
              ></button>
              <button
                type="button"
                onClick={() => switchTheme("purple")}
                className="third t-btn"
              ></button>
            </div>
          </div>
        </section>
        <section className="output">
          <div className="result">{result}</div>
        </section>
        <section className="input">
          <Number result={result} setResult={setResult} />
        </section>
      </div>
    </main>
  );
}

export default App;
